export const AvatarNavbarFacesEmotionsIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1460_91897)">
        <path
          d="M10.21 19.37C15.27 19.37 19.37 15.27 19.37 10.21C19.37 5.15 15.27 1.04 10.21 1.04C5.15 1.04 1.04 5.15 1.04 10.21C1.04 15.27 5.15 19.37 10.21 19.37Z"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M6.46 10.21C7.15 10.21 7.71 9.65 7.71 8.96C7.71 8.27 7.15 7.71 6.46 7.71C5.77 7.71 5.21 8.27 5.21 8.96C5.21 9.65 5.77 10.21 6.46 10.21Z"
          fill="#737373"
        />
        <path
          d="M7.71 12.71C7.71 13.37 7.97 14.01 8.44 14.48C8.91 14.95 9.55 15.21 10.21 15.21C10.87 15.21 11.51 14.95 11.98 14.48C12.45 14.01 12.71 13.37 12.71 12.71"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
        />
        <path
          d="M11.88 8.54H14.38"
          stroke="#737373"
          strokeWidth="1.15"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_1460_91897">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
